import { render, staticRenderFns } from "./ReportsDetailData.vue?vue&type=template&id=24460387"
import script from "./ReportsDetailData.vue?vue&type=script&lang=ts"
export * from "./ReportsDetailData.vue?vue&type=script&lang=ts"
import style0 from "./ReportsDetailData.vue?vue&type=style&index=0&id=24460387&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports